<template>
  <DialogDrawer
    ref="dialog"
    v-bind="props"
    @submit="(event: Event) => $emit('submit', event)"
    @close="$emit('close')"
  >
    <template v-for="(_, slot) of $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </DialogDrawer>
</template>
<script setup lang="ts">
import DialogDrawer from '@/components/shared/custom/DialogDrawer/DialogDrawer.vue';
import {type DialogDrawerProps} from '@/components/shared/custom/DialogDrawer/DialogDrawer.types';

const dialog = useTemplateRef<InstanceType<typeof DialogDrawer>>('dialog');
const props = defineProps<DialogDrawerProps>();
defineEmits<{submit: [event: Event]; close: []}>();

onMounted(() => {
  dialog.value?.openModal();
});

onUnmounted(() => {
  dialog.value?.close();
});
</script>
